/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import './LoginPage.scss';
import { Link, navigate } from 'gatsby';

import { useLazyQuery, useMutation } from '@apollo/client';
import { connect } from 'react-redux';
import {
  customerAccessTokenCreate,
  checkoutCustomerAssociateV2,
  checkoutShippingAddressUpdateV2,
} from '../../../components/shared/mutation/mutation.js';
import { getCustomer } from '../../../components/shared/query/query.js';
import store from '../../../state/createStore';

const mapStateToProps = (state) => ({
  customerAccessTokenObject: state.customerAccessTokenObject,
  customer: state.customer,
});

export default connect(mapStateToProps)((props) => {
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [
    checkoutCustomerAssociateV2Mutation,
    { data: checkoutCustomerAssociateV2Data, error: checkoutCustomerAssociateV2Error },
  ] = useMutation(checkoutCustomerAssociateV2);
  const [checkoutShippingAddressUpdateV2Mutation, {}] = useMutation(checkoutShippingAddressUpdateV2);
  const [
    customerAccessTokenCreateQuery,
    { data: customerAccessTokenCreateData, error: customerAccessTokenCreateError },
  ] = useMutation(customerAccessTokenCreate);

  const [getCustomerQuery, { data: getCustomerData, error: getCustomerError }] = useLazyQuery(getCustomer);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (props.customer && props.customer.id !== '') {
      navigate('/account');
    }
  }, []);

  function loginButtonClick(event) {
    if (loginEmail !== '' || loginPassword !== '') {
      customerAccessTokenCreateQuery({
        variables: {
          input: {
            email: loginEmail,
            password: loginPassword,
          },
        },
      });
    } else {
      alert('fill in the form');
    }
  }

  useEffect(() => {
    if (customerAccessTokenCreateError) {
      console.log(customerAccessTokenCreateError);
      return;
    }
    if (!customerAccessTokenCreateData) {
      return;
    }
    if (customerAccessTokenCreateData.customerAccessTokenCreate.customerUserErrors[0]) {
      alert(customerAccessTokenCreateData.customerAccessTokenCreate.customerUserErrors[0].message);
      return;
    }

    store().dispatch({
      type: 'CUSTOMERTOKEN_UPDATE',
      payload: {
        customerAccessTokenObject: customerAccessTokenCreateData.customerAccessTokenCreate.customerAccessToken,
      },
    });
    getCustomerQuery({
      variables: {
        customerAccessToken: customerAccessTokenCreateData.customerAccessTokenCreate.customerAccessToken.accessToken,
      },
    });
  }, [customerAccessTokenCreateError, customerAccessTokenCreateData]);

  useEffect(() => {
    if (!getCustomerData) {
      return;
    }
    let tempArray = [];
    const clonedCustomer = JSON.parse(JSON.stringify(getCustomerData.customer));
    for (const singleEdge of clonedCustomer.addresses.edges) {
      tempArray.push(singleEdge.node);
    }
    clonedCustomer.addresses = tempArray;
    tempArray = [];
    for (const singleEdge of clonedCustomer.orders.edges) {
      tempArray.push(singleEdge.node);
    }
    clonedCustomer.orders = tempArray;
    store().dispatch({
      type: 'UPDATE_CUSTOMER',
      payload: {
        customer: clonedCustomer,
      },
    });
    checkoutCustomerAssociateV2Mutation({
      variables: {
        checkoutId: store().getState().checkout.id,
        customerAccessToken: store().getState().customerAccessTokenObject.accessToken,
        currencyCode: store().getState().currency.currencyCode,
      },
    });
    if (clonedCustomer.defaultAddress) {
      checkoutShippingAddressUpdateV2Mutation({
        variables: {
          checkoutId: store().getState().checkout.id,
          shippingAddress: {
            address1: clonedCustomer.defaultAddress.address1,
            address2: clonedCustomer.defaultAddress.address2,
            firstName: clonedCustomer.defaultAddress.firstName,
            lastName: clonedCustomer.defaultAddress.lastName,
            company: clonedCustomer.defaultAddress.company,
            city: clonedCustomer.defaultAddress.city,
            zip: clonedCustomer.defaultAddress.zip,
            country: clonedCustomer.defaultAddress.country,
            province: clonedCustomer.defaultAddress.province,
          },
        },
      });
    }
    store().dispatch({ type: 'SIGN_IN' });
    navigate('/account');
  }, [getCustomerData, getCustomerError]);

  return (
    <div className="mainLoginRegisterPage">
      <div className="cus_sign_container">
        <h2 className="sign_bg_tt">ANMELDEN</h2>
        <div className="custom_signin">
          <div className="cus_page-content">
            <div className="cus_grid__item">
              <div className="login_img">
                <img
                  className="lazyload"
                  srcSet="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_100x.png?v=1585121200 100w,
            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_200x.png?v=1585121200 200w,
            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_400x.png?v=1585121200 400w,
            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_800x.png?v=1585121200 800w,
            https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_ffeac721-e1ed-4980-b7c0-4877d67bd1a2_1600x.png?v=1585121200 1600w,"
                  alt="GOBI CASHMERE"
                />
              </div>
            </div>
          </div>

          <div className="cus_page-content">
            <div className="cus_grid__item">
              <header className="section-header">
                <h1 className="section-header__title"> ANMELDUNG</h1>
              </header>
              <span className="req_tt">
                Neuer Benutzer?{' '}
                <Link
                  style={{
                    color: '#46A3F9',
                    fontWeight: '600',
                  }}
                  to="/account/register"
                >
                  Konto erstellen
                </Link>
              </span>

              <div id="CustomerLoginForm" className="form-vertical">
                <form>
                  <label htmlFor="CustomerEmail"> Email *</label>
                  <div>
                    <input
                      placeholder="Email"
                      type="email"
                      name="customer[email]"
                      id="CustomerEmail"
                      className="input-full"
                      autoCorrect="off"
                      autoCapitalize="off"
                      autoFocus
                      onChange={(e) => {
                        setLoginEmail(e.target.value);
                      }}
                    />
                  </div>

                  <div
                    className="grid"
                    style={{
                      display: 'flex',
                    }}
                  >
                    <div
                      className="grid__item one-half"
                      // style={{
                      // 	paddingLeft: '0px'
                      // }}
                    >
                      <label htmlFor="CustomerPassword">Passwort *</label>
                    </div>
                    <div
                      className="grid__item one-half text-right"
                      // style={{
                      // 	paddingLeft: '0px'
                      // }}
                    >
                      <small className="label-info">
                        <Link
                          to="/account/reset"
                          style={{
                            color: '#46A3F9',
                            fontWeight: '600',
                          }}
                          id="RecoverPassword"
                          className="js-no-transition"
                        >
                          Passwort vergessen?
                        </Link>
                      </small>
                    </div>
                  </div>
                  <div>
                    <input
                      placeholder="Passwort"
                      type="password"
                      name="customer[password]"
                      id="CustomerPassword"
                      onChange={(e) => {
                        setLoginPassword(e.target.value);
                      }}
                    />
                  </div>

                  <div className="cus_btn">
                    <button type="button" className="btn login_cus_btn" onClick={loginButtonClick}>
                      ANMELDEN
                    </button>
                  </div>
                </form>
              </div>

              <div id="RecoverPasswordForm" className="hide">
                <div className="form-vertical">
                  <h2> 'customer.recover_password.title' </h2>
                  <p> 'customer.recover_password.subtext'</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
